/**
 * Created by chenzheyu on 2017/6/21.
 */
import banner from '../../api/banner'
import initdata from '../../api/initdata'
import city from '../../api/city'
import Toucth from '../../assets/js/method'
import JSONBig from 'json-bigint-xk'
// import configure from '../configure'

const state = {
  location: {
    name: '获取定位中...',
    city: '选择城市',
    ad_code: null,
    city_code: null,
    detailedAddress: null,
    lng: null,
    lat: null
  },
  servesType: {},
  servesTypeNav: [],
  banners: {
    daijia: [],
    paotui: [],
    zhuanche: [],
    zhuanxian: [],
    freight: []
  },
  companyInfo: null,
  infoData: '',
  unfilledOrder: [],
  unfilledOrderState: {
    paotui: true,
    zhuanche: true,
    daijia: true,
    zhuanxian: true,
    huoyun: true
  },
  OrderNav: [],
  mobile: {
    iPhone: false,
    Android: false,
    fromData: false
  },
  baiduMapSite: [],
  nearDrivers: 0,
  mapState: 'amap',
  addressRecord: {
    paotui: {},
    daijia: [],
    zhuanche: {},
    zhuanxian: {}
  },
  business: {  // 子业务
    daijia: {}
  }
}
const mutations = {
  getInitInfo (state, data) {
    let obj = data.obj
    state.infoData = obj
    state.companyInfo = obj.companyinfo
    state.servesTypeNav = []
    let servesNav = []
    let orderNav = []
    if (obj.business) {
      obj.business.forEach((business) => {
        // 仅识别代驾类型
        if (business.business === 'daijia') {
          business['name'] = '代驾'
          business['router'] = '/daijia?app_key=' + window.configure.appKey
          business['OrderNavRouter'] = '/orderRecord/daijia'
          state.servesType[business.business] = business
          let OrderNavObj = {name: business.name, url: business.OrderNavRouter}
          let servesNavObj = {name: business.name, url: business.router, business: business.business}
          servesNav.push(servesNavObj)
          orderNav.push(OrderNavObj)
        }
      })
    }
    state.servesTypeNav = servesNav
    state.OrderNav = orderNav
    if (data.fn) {
      data.fn(obj)
    }
  },
  positioningMutation (state, obj) {
    // console.log('positioningMutation', obj, typeof obj.result.city)
    if (obj.result && JSON.stringify(obj.result).indexOf('失败') < 0) {
      let result = obj.result
      let city = ''
      if (result.city && typeof result.city === 'string') {
        city = result.city
      } else if (result.city && typeof result.city === Array && result.city.length > 0) {
        city = result.city[0]
      } else if (result.detailedAddress.indexOf('市') !== -1) {
        city = result.detailedAddress.substring(result.detailedAddress.indexOf('省') + 1, result.detailedAddress.indexOf('市') + 1)
      } else {
        city = '选择城市'
      }
      state.location.name = result.name
      // console.log('state.location', state.location)
      state.location = {
        name: result.name,
        ad_code: result.ad_code,
        city_code: result.city_code,
        city: city,
        detailedAddress: result.detailedAddress,
        lng: result.lng,
        lat: result.lat
      }
      // console.log('state.location', state.location)
      window.configure.location = state.location
      // console.log('window.configure.location赋值', window.configure.location)
      if (Toucth.ismobile(1) + '' === '0') {
        state.mobile.iPhone = true
      } else {
        state.mobile.Android = true
      }
      // console.log('FormData', new FormData())
      if (new FormData()) {
        state.mobile.fromData = true
      }
      if (result && result.lng && result.lat && result.city_code && obj.fn) {
        obj.fn(true)
      }
    } else {
      obj.fn(false)
    }
  },
  banner (state, obj) {
    let banner = obj.banner
    let type = obj.type
    let data = []
    for (let i = 0; i < banner.content.length; i++) {
      data.push({
        imgUrl: banner.content[i].image,
        htmlUrl: banner.content[i].link ? banner.content[i].link : banner.content[i].content
      })
    }
    state.banners[type] = data
  },
  unfilledOrder (state, obj) {
    if (obj.code === 1) {
      state.unfilledOrder = obj.orders || []
    }
  },
  unfilledOrderState (state, obj) {
    switch (obj.type) {
      case 'paotui':
        state.unfilledOrderState.paotui = obj.state
        break
      case 'zhuanche':
        state.unfilledOrderState.zhuanche = obj.state
        break
      case 'daijia':
        state.unfilledOrderState.daijia = obj.state
        break
      case 'zhuanxian':
        state.unfilledOrderState.zhuanxian = obj.state
        break
      case 'huoyun':
        state.unfilledOrderState.huoyun = obj.state
        break
    }
  },
  addressRecord (state, obj) {
    if (obj.address.lng !== '' && obj.address.lat !== '' && obj.type === 'daijia') {
      let check = true
      let daijia = state.addressRecord.daijia
      for (let i = 0; i < daijia.length; i++) {
        if (daijia[i].address.name === obj.address.name && daijia[i].address.detailedAddress === obj.address.detailedAddress && daijia[i].address.lng === obj.address.lng && daijia[i].address.lat === obj.address.lat) {
          if (i !== 0) {
            daijia[0] = [daijia[i], daijia[i] = daijia[0]][0]
          }
          check = false
        }
      }
      if (check) {
        if (state.addressRecord.daijia.length < 5) {
          state.addressRecord.daijia.unshift({
            address: obj.address,
            recordTime: obj.recordTime
          })
        } else {
          state.addressRecord.daijia.unshift({
            address: obj.address,
            recordTime: obj.recordTime
          })
          state.addressRecord.daijia.pop()
        }
      }
    }
    if (obj.type === 'zhuanche') {
      if (!state.addressRecord.zhuanche[obj.sonType]) {
        state.addressRecord.zhuanche[obj.sonType] = []
        state.addressRecord.zhuanche[obj.sonType].unshift({
          address: obj.address,
          recordTime: obj.recordTime
        })
      }
      if (state.addressRecord.zhuanche[obj.sonType]) {
        let check = true
        let zhuanche = state.addressRecord.zhuanche[obj.sonType]
        for (let i = 0; i < state.addressRecord.zhuanche[obj.sonType].length; i++) {
          if (zhuanche[i].address.name === obj.address.name && zhuanche[i].address.detailedAddress === obj.address.detailedAddress && zhuanche[i].address.lng === obj.address.lng && zhuanche[i].address.lat === obj.address.lat) {
            if (i !== 0) {
              zhuanche[0] = [zhuanche[i], zhuanche[i] = zhuanche[0]][0]
            }
            check = false
          }
        }
        if (check) {
          if (state.addressRecord.zhuanche[obj.sonType].length < 5) {
            state.addressRecord.zhuanche[obj.sonType].unshift({
              address: obj.address,
              recordTime: obj.recordTime
            })
          } else {
            state.addressRecord.zhuanche[obj.sonType].unshift({
              address: obj.address,
              recordTime: obj.recordTime
            })
            state.addressRecord.zhuanche[obj.sonType].pop()
          }
        }
      }
    }
    localStorage.setItem('easyminaddressrecord', JSON.stringify(state.addressRecord))
    if (obj.fn) {
      obj.fn()
    }
  },
  getAddressRecord (state, obj) {
    if (localStorage.getItem('easyminaddressrecord') !== 'undefined') {
      if (JSONBig.parse(localStorage.getItem('easyminaddressrecord'))) {
        state.addressRecord = JSONBig.parse(localStorage.getItem('easyminaddressrecord'))
      }
      if (obj.fn) {
        obj.fn()
      }
    }
  },
  getNearDrivers (state, nearDrivers) { // 获取附近司机 nearDrivers 信息
    if (nearDrivers.code === 1) {
      let arr = []
      if (nearDrivers.emploies) {
        nearDrivers.emploies.forEach(item => {
          if (item.status === '10') {
            arr.push(item)
          }
        })
      }
      state.nearDrivers = arr
    }
  },
  getBusiness (state, business) { // 获取 子业务
    if (business.code === 1 && business.categories && business.categories.length > 0) {
      state.business[business.business] = business.categories
    }
  }
}

const getters = {
  daijiaBanner: state => {
    return state.banners.daijia
  },
  paotuiBanner: state => {
    return state.banners.paotui
  },
  zhuancheBanner: state => {
    return state.banners.zhuanche
  },
  zhuanxianBanner: state => {
    return state.banners.zhuanxian
  },
  huoyunBanner: state => {
    return state.banners.freight
  },
  servesTypeNav: state => {
    return state.servesTypeNav
  },
  infoData: state => {
    return state.infoData
  },
  companyInfo: state => {
    return state.companyInfo
  },
  unfilledOrder: state => {
    return state.unfilledOrder
  },
  orderNav: state => {
    return state.OrderNav
  },
  positioning: state => {
    return state.location
  },
  mobileState: state => {
    return state.mobile
  },
  unfilledOrderState: state => {
    return state.unfilledOrderState
  },
  mapState: state => {
    return state.mapState
  },
  addressRecord: state => {
    return state.addressRecord
  },
  getCity: state => {
    return city
  },
  getNearDrivers: state => state.nearDrivers,  // 获取附近司机
  DJBusiness: state => state.business.daijia  // 代驾 子业务
}

const actions = {
  getWxAppId ({commit}, obj) {
    initdata.getWxAppId(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  getjsApiTicket ({commit}, obj) {
    initdata.getjsApiTicket(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  getInitInfo ({commit}, obj) {
    initdata.getInitInfo(obj, (data) => {
      commit('getInitInfo', {fn: obj.fn, obj: data})
    })
  },
  positioningActions ({commit}, obj) { // 获取定位
    initdata.positioningApi(obj, (data) => {
      // let positions = true
      console.log('获取定位--actions--positioning', data)
      if (data.lng && data.lat && data.ad_code && data.city_code) {
        // if (state.mapState === 'google') { // 判断是不是 谷歌地图
        //   positions = Toucth.GoogleEncrypt({
        //     lng: data.lng,
        //     lat: data.lat
        //   })
        //   initdata.googleForLongitude(positions, (data) => {
        //     commit('positioningMutation', {result: data, fn: obj.fn})
        //   })
        // } else {
        //   commit('positioningMutation', {result: data, fn: obj.fn})
        // }
        commit('positioningMutation', {result: data, fn: obj.fn})
      } else {
        // commit('positioningMutation', {result: data, fn: obj.fn})
        alert('抱歉，无法获取位置信息')
      }
    })
  },
  getNearDrivers ({commit}, obj) { // 查询附近司机
    initdata.getNearDrivers(obj, (data) => {
      commit('getNearDrivers', data)
    })
  },
  banner ({commit}, obj) {
    banner.banner(obj, (banner, type) => {
      commit('banner', {banner: banner, type: type})
    })
  },
  unfilledOrder ({commit}, obj) { // 查询未完成订单
    initdata.unfilledOrder(obj, (data) => {
      commit('unfilledOrder', data)
    })
  },
  routePlanning ({commit}, obj) { // 路径规划
    initdata.routePlanning(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  getBudgetPrice ({commit}, obj) { // 预算费用
    initdata.getBudgetPrice(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  getBusiness ({commit}, obj) { // 根据公司  主业务  获取子业务
    initdata.getBusiness(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      commit('getBusiness', data)
    })
  },
  getCouponType ({commit}, obj) { // 根据业务查询  优惠券
    initdata.getCouponType(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },

  postCreateOrder ({commit}, obj) { // 根据业务 下单
    initdata.postCreateOrder(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  systemConfig ({commit}, obj) {
    initdata.systemConfig(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  getTags ({commit}, obj) { // 获取 评价标签集合
    initdata.getTags(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  urlEnabled ({commit}, obj) {
    initdata.urlEnabled(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(true)
      } else if (obj.fn) {
        obj.fn(false)
      }
    })
  },
  unfilledOrderState ({commit}, obj) {
    commit('unfilledOrderState', obj)
  },
  googleMapSite ({commit}, obj) {
    initdata.googleMapSite(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  amapMapSite ({commit}, obj) {
    initdata.amapMapSite(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  addressRecord ({commit}, obj) {
    commit('addressRecord', obj)
  },
  getAddressRecord ({commit}, obj) {
    commit('getAddressRecord', obj)
  },
  getNotice ({commit}, obj) { // 获取用户消息
    initdata.getNotice(obj, (data) => {
      if (obj.fn) {
        obj.fn(data)
      }
    })
  },
  countLine ({commit}, obj) {
    initdata.countLine(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/initdata.js